export default __webpack_public_path__ + "static/media/save.2791225c.svg";